import { IconComponent } from './types';

const SvgComponent: IconComponent = (props) => (
  <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m12.851 4.934-.005-.01-1.117-1.932a.785.785 0 0 0-.931-.359l-.018.006-.017.007-1.14.457a4.592 4.592 0 0 0-.557-.325L8.895 1.57l-.002-.012A.782.782 0 0 0 8.12.9H5.88c-.4 0-.707.292-.767.657l-.002.012-.172 1.21a4.708 4.708 0 0 0-.556.324l-1.14-.457-.008-.003-.008-.003a.778.778 0 0 0-.95.352L1.165 4.925v.001a.765.765 0 0 0 .204 1.005l.95.739c-.012.108-.02.22-.02.33 0 .105.004.215.013.327l-.962.749a.786.786 0 0 0-.202.991l.006.01 1.117 1.932c.206.37.618.458.931.359l.018-.006.017-.007 1.14-.457c.175.12.36.228.557.325l.17 1.208.003.016.003.016a.787.787 0 0 0 .77.637h2.24a.772.772 0 0 0 .77-.672l.17-1.205c.196-.096.383-.205.56-.325l1.137.457.008.003.007.003a.778.778 0 0 0 .95-.352l1.118-1.932.006-.011a.77.77 0 0 0-.204-.992l-.953-.749a4.92 4.92 0 0 0 0-.651l.961-.749a.786.786 0 0 0 .201-.991ZM7 8.6c-.879 0-1.6-.72-1.6-1.6 0-.878.721-1.6 1.6-1.6.879 0 1.6.722 1.6 1.6 0 .88-.721 1.6-1.6 1.6Z"
      stroke="#000"
    />
  </svg>
);

export default SvgComponent;
